<script context="module">
  import { create_multi_line_chart_dataset, create_single_line_chart_dataset } from "./OrSixChartUtils.svelte";
  import { create_bar_chart_dataset, lead_link } from "./OrThreeChartUtils.svelte";

  export function calc_or4_block_conversions(
    opportunities_total,
    column_name_lower,
    column_name_upper,
    name,
    marketing_start_date,
    marketing_end_date,
    marketing_start_date_compare,
    marketing_end_date_compare,
    filter = false,
    filter_value = false,
  ) {
    let ret = {};
    // ret['per_country'] = calc_per_country(data, months, column_name);
    // ret['per_salesperson'] = calc_per_salesperson(data, months, column_name);
    // ret['per_campaign'] = calc_per_campaign(data, months, column_name);
    // ret['per_source'] = calc_per_source(data, months, column_name);

    let list_all_daycounts = [];

    let opportunities_filtered_first = [];
    let opportunities_filtered_compare = [];

    opportunities_total.forEach((element) => {
      if (!element[column_name_lower] || !element[column_name_upper]) {
        element[name] = false;
        return;
      }

      if (filter) {
        if (!element[filter]) {
          element[name] = false;
          return;
        }
        if (element[filter][1] != filter_value) {
          element[name] = false;
          return;
        }
      }

      var from = new Date(element[column_name_lower]);
      var to = new Date(element[column_name_upper]);

      var Difference_In_Time = to.getTime() - from.getTime();
      // To calculate the no. of days between two dates
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      Difference_In_Days = Math.round(Difference_In_Days);
      element[name] = Difference_In_Days;

      if (to > marketing_start_date && to < marketing_end_date) {
        opportunities_filtered_first.push(element);
      }
      if (to > marketing_start_date_compare && to < marketing_end_date_compare) {
        opportunities_filtered_compare.push(element);
      }
    });

    // ret['average'] = get_conversion_days_average(marketing_start_date, name);

    var tmp = get_conversion_days_average_grouping(opportunities_filtered_first, name, "country");
    ret["per_country"] = create_bar_chart_dataset(tmp["keys"], tmp["values"], "");
    tmp = get_conversion_days_average_grouping(opportunities_filtered_first, name, "user");
    ret["per_salesperson"] = create_bar_chart_dataset(tmp["keys"], tmp["values"], "");
    tmp = get_conversion_days_average_grouping(opportunities_filtered_first, name, "campaign");
    ret["per_campaign"] = create_bar_chart_dataset(tmp["keys"], tmp["values"], "");
    tmp = get_conversion_days_average_grouping(opportunities_filtered_first, name, "source");
    ret["per_source"] = create_bar_chart_dataset(tmp["keys"], tmp["values"], "");

    var tmp = get_conversion_days_average_grouping(opportunities_filtered_compare, name, "country");
    ret["per_country_compare"] = create_bar_chart_dataset(tmp["keys"], tmp["values"], "");
    tmp = get_conversion_days_average_grouping(opportunities_filtered_compare, name, "user");
    ret["per_salesperson_compare"] = create_bar_chart_dataset(tmp["keys"], tmp["values"], "");
    tmp = get_conversion_days_average_grouping(opportunities_filtered_compare, name, "campaign");
    ret["per_campaign_compare"] = create_bar_chart_dataset(tmp["keys"], tmp["values"], "");
    tmp = get_conversion_days_average_grouping(opportunities_filtered_compare, name, "source");
    ret["per_source_compare"] = create_bar_chart_dataset(tmp["keys"], tmp["values"], "");

    //zurückgeben in key tables

    ret["tables"] = {};

    ret["tables"]["country_table"] = merge(
      ret["per_country"]["labels"],
      ret["per_country_compare"]["labels"],
      ret["per_country"]["datasets"][0]["data"],
      ret["per_country_compare"]["datasets"][0]["data"],
    );
    ret["tables"]["salesperson_table"] = merge(
      ret["per_salesperson"]["labels"],
      ret["per_salesperson_compare"]["labels"],
      ret["per_salesperson"]["datasets"][0]["data"],
      ret["per_salesperson_compare"]["datasets"][0]["data"],
    );
    ret["tables"]["campaign_table"] = merge(
      ret["per_campaign"]["labels"],
      ret["per_campaign_compare"]["labels"],
      ret["per_campaign"]["datasets"][0]["data"],
      ret["per_campaign_compare"]["datasets"][0]["data"],
    );
    ret["tables"]["source_table"] = merge(
      ret["per_source"]["labels"],
      ret["per_source_compare"]["labels"],
      ret["per_source"]["datasets"][0]["data"],
      ret["per_source_compare"]["datasets"][0]["data"],
    );

    ret["tables"]["sum"] = ret["tables"]["country_table"]["sum"];
    ret["tables"]["sum_compare"] = ret["tables"]["country_table"]["sum_compare"];

    // let tables = {};
    // tables['country_table'] = calc_table(
    //   data,
    //   marketing_start_date,
    //   marketing_end_date,
    //   marketing_start_date_compare,
    //   marketing_end_date_compare,
    //   'country',
    //   column_name
    // );

    return ret;
  }

  function merge(list_index, list_compare_index, list_values, list_values_compare) {
    var merge_index = list_index.concat(list_compare_index);

    merge_index = merge_index.filter((item, index) => {
      return merge_index.indexOf(item) == index;
    });

    let final_list = [];

    let sum = 0;
    let sum_compare = 0;
    let sum_count = 0;
    let sum_count_compare = 0;

    merge_index.forEach((key) => {
      let index_1 = list_index.indexOf(key);
      let index_2 = list_compare_index.indexOf(key);

      let value_1 = 0;
      let value_2 = 0;

      if (index_1 != -1) {
        value_1 = list_values[index_1];
        sum_count = sum_count + 1;
      }
      if (index_2 != -1) {
        value_2 = list_values_compare[index_2];
        sum_count_compare = sum_count_compare + 1;
      }

      sum = sum + parseFloat(value_1);
      sum_compare = sum_compare + parseFloat(value_2);

      final_list.push({ name: key, "#": value_1.toString(), compare: value_2.toString() });
    });

    sum = (sum / sum_count).toFixed(2);
    sum_compare = (sum_compare / sum_count_compare).toFixed(2);

    return { keys: merge_index, values: final_list, sum: sum, sum_compare: sum_compare };
  }

  function insights_year_chart(insights, group_name, list_of_groups, list_of_values, labels, use_max = false) {
    let months = get_month_index_list();

    let return_dict = {};

    // console.log("insights: ", insights)

    list_of_groups.forEach((group) => {
      if (!(group in return_dict)) {
        return_dict[group] = {};
      }

      months.forEach((m) => {
        if (!(m in return_dict[group])) {
          return_dict[group][m] = {};
          list_of_values.forEach((v) => {
            if (!(v in return_dict[group][m])) {
              return_dict[group][m][v] = 0;
            }
          });
        }
      });
    });

    insights.forEach((insight) => {
      var m = insight["tag"].substring(0, 7);
      var group = insight[group_name];

      list_of_values.forEach((v) => {
        var value = insight[v];
        if (!(group in return_dict)) {
          return;
        }
        if (m in return_dict[group]) {
          if (use_max) {
            if (value > return_dict[group][m][v]) {
              return_dict[group][m][v] = value;
            }
          } else {
            return_dict[group][m][v] = return_dict[group][m][v] + value;
          }
        }
      });
    });

    let list_of_lists = [];

    // console.log("return_dict: ", return_dict)

    list_of_groups.forEach((group) => {
      var group_dict = return_dict[group];

      list_of_values.forEach((v) => {
        var values_list = [];
        months.forEach((m) => {
          values_list.push(return_dict[group][m][v]);
        });
        list_of_lists.push(values_list);
      });
    });

    return create_multi_line_chart_dataset(months, list_of_lists, labels);
  }

  function colorize_table_entry(a, b) {
    var first_string = "";

    if (a > b) {
      first_string = '<div style="color:' + "#6fb899" + '">' + a.toString() + "</div>";
    } else {
      if (b > a * 2) {
        first_string = '<div style="color:' + "#c70000" + '">' + a.toString() + "</div>";
      } else {
        if (b > (a * 1, 4)) {
          first_string = '<div style="color:' + "#ff8800" + '">' + a.toString() + "</div>";
        } else {
          if (b > (a * 1, 2)) {
            first_string = '<div style="color:' + "#FFFF00" + '">' + a.toString() + "</div>";
          } else {
            first_string = a.toString();
          }
        }
      }
    }

    //'#6fb899' : '#c70000';

    return first_string + "/" + b.toString();
  }

  export function insights_bearbeiten(
    insights,
    marketing_start_date,
    marketing_end_date,
    marketing_start_date_compare,
    marketing_end_date_compare,
  ) {
    //     - reichweite_bezahlt
    // - reichweite_organisch
    // - follower (KEINE SUMME)
    // - seitenaufrufe
    // - individuelle_videoaufrufe_bezahlt
    // - individuelle_videoaufrufe_organisch

    // = create_multi_line_chart_dataset(keys_opports, [val_open_opports], ['open']);

    // let charts_columns = [];
    // let follower_values = [];
    // let reichweite_organisch = [];
    // let reichweite_bezahlt = [];

    // let follower_chart;
    // let reichweite_chart;

    // let follower_values_week_sum = 0;
    // let reichweite_organisch_week_sum = 0;
    // let reichweite_bezahlt_week_sum = 0;

    // let counter = 0;
    // let anzahl_tage = 7

    // console.log("insights: ", insights)

    // insights.forEach((insight) => {

    //   if(counter % anzahl_tage == (anzahl_tage-1)){
    //     charts_columns.push(insight['tag'].substring(0,10));

    //     follower_values.push(follower_values_week_sum / anzahl_tage);
    //     reichweite_organisch.push(reichweite_organisch_week_sum);
    //     reichweite_bezahlt.push(reichweite_bezahlt_week_sum);

    //     follower_values_week_sum = 0;
    //     reichweite_organisch_week_sum = 0;
    //     reichweite_bezahlt_week_sum = 0;
    //   }else{
    //     follower_values_week_sum = follower_values_week_sum + insight['follower']
    //     reichweite_organisch_week_sum = reichweite_organisch_week_sum + insight['reichweite_organisch']
    //     reichweite_bezahlt_week_sum = reichweite_bezahlt_week_sum + insight['reichweite_bezahlt']
    //   }

    //   counter = counter + 1;

    // });

    // follower_chart = create_multi_line_chart_dataset(charts_columns, [follower_values], ['Follower']);
    //  reichweite_chart = create_multi_line_chart_dataset(charts_columns, [reichweite_organisch, reichweite_bezahlt], ['Reichweite organisch', 'Reichweite bezahlt']);

    // let months = get_month_index_list();

    // follower_chart = linechart_with_grouping(insights, months, 'tag', 'page_id');

    let follower_chart = insights_year_chart(
      insights,
      "page_name",
      ["SmaXtec US", "SmaXtec UK", "SmaXtec New Zealand & Australia", "SmaXtec IRL", "smaXtec animal care"],
      ["follower"],
      ["SmaXtec US", "SmaXtec UK", "SmaXtec New Zealand & Australia", "SmaXtec IRL", "smaXtec animal care"],
      true,
    );
    let reichweite_chart = insights_year_chart(
      insights,
      "page_name",
      ["SmaXtec US", "SmaXtec UK", "SmaXtec New Zealand & Australia", "SmaXtec IRL", "smaXtec animal care", "Instagram"],
      ["reichweite_bezahlt", "reichweite_organisch"],
      [
        "SmaXtec US bezahlt",
        "SmaXtec US organisch",
        "SmaXtec UK bezahlt",
        "SmaXtec UK organisch",
        "SmaXtec New Zealand & Australia bezahlt",
        "SmaXtec New Zealand & Australia organisch",
        "SmaXtec IRL bezahlt",
        "SmaXtec IRL organisch",
        "smaXtec animal care bezahlt",
        "smaXtec animal care organisch",
        "Instagram bezahlt",
        "Instagram organisch",
      ],
      false,
    );

    let interesting_metrix = [
      "reichweite_bezahlt",
      "reichweite_organisch",
      "follower",
      //'seitenaufrufe',
      "individuelle_videoaufrufe_bezahlt",
      "individuelle_videoaufrufe_organisch",
    ];

    let companies = [];

    let return_dict = {};
    let return_dict_compare = {};

    insights.forEach((insight) => {
      var page_name = insight["page_name"];

      if (!companies.includes(insight["page_name"])) {
        companies.push(insight["page_name"]);
      }

      var date = new Date(insight["tag"]);

      if (date >= marketing_start_date && date <= marketing_end_date) {
        if (!(insight["page_name"] in return_dict)) {
          return_dict[insight["page_name"]] = {};
        }

        interesting_metrix.forEach((metric) => {
          var value = insight[metric];

          if (!(metric in return_dict[insight["page_name"]])) {
            return_dict[insight["page_name"]][metric] = 0;
          }
          if (metric != "follower" || page_name == "Instagram") {
            return_dict[insight["page_name"]][metric] = return_dict[insight["page_name"]][metric] + value;
          } else {
            if (value > return_dict[insight["page_name"]][metric]) {
              return_dict[insight["page_name"]][metric] = value;
            }
          }
        });
      }

      if (date >= marketing_start_date_compare && date <= marketing_end_date_compare) {
        if (!(insight["page_name"] in return_dict_compare)) {
          return_dict_compare[insight["page_name"]] = {};
        }

        interesting_metrix.forEach((metric) => {
          var value = insight[metric];

          if (!(metric in return_dict_compare[insight["page_name"]])) {
            return_dict_compare[insight["page_name"]][metric] = 0;
          }
          if (metric != "follower" || page_name == "Instagram") {
            return_dict_compare[insight["page_name"]][metric] = return_dict_compare[insight["page_name"]][metric] + value;
          } else {
            if (value > return_dict_compare[insight["page_name"]][metric]) {
              return_dict_compare[insight["page_name"]][metric] = value;
            }
          }
        });
      }
    });

    // console.log("companies: ", companies)

    // console.log('return_dict: ', return_dict);
    // console.log("return_dict_compare: ", return_dict_compare)

    let all_lists = [];

    companies.forEach((c) => {
      let list_entry = {};
      list_entry["page_name"] = c;

      interesting_metrix.forEach((i) => {
        // console.log("i: ", i)
        // console.log("return_dict[c]: ", return_dict[c])
        console.log("i: ", i);
        var x = colorize_table_entry(return_dict[c][i], return_dict_compare[c][i]);

        list_entry[i] = x;
      });

      all_lists.push(list_entry);
    });

    // console.log("all_lists: ", all_lists)

    return {
      table: {
        columns: [
          "Seite",
          "Reichweite (bezahlt)",
          "Reichweite (organisch)",
          "Follower",
          //'Seitenaufrufe',
          "Videoaufrufe (bezahlt)",
          "Videoaufrufe (organisch)",
        ],
        values: all_lists,
      },
      follower_chart: follower_chart,
      reichweite_chart: reichweite_chart,
    };
  }

  function get_conversion_days_average(data, name) {
    var count = 0;
    var sum = 0;

    data.forEach((element) => {
      if (element[name]) {
        count = count + 1;
        sum = sum + element[name];
      }
    });

    return (sum / count).toFixed(2);
  }

  function get_conversion_days_average_grouping(data, name, column_field) {
    var count = {};
    var sum = {};

    var list_of_groups = [];

    data.forEach((element) => {
      if (element[column_field]) {
        count[element[column_field]] = 0;
        sum[element[column_field]] = 0;
      }
    });

    data.forEach((element) => {
      if (!element[column_field]) {
        return;
      }

      if (!list_of_groups.includes(element[column_field])) {
        list_of_groups.push(element[column_field]);
      }

      if (element[name]) {
        count[element[column_field]] = count[element[column_field]] + 1;
        sum[element[column_field]] = sum[element[column_field]] + element[name];
      }
    });

    var values = [];

    list_of_groups.forEach((g) => {
      if (count[g]) {
        values.push((sum[g] / count[g]).toFixed(2));
      } else {
        values.push(false);
      }
    });

    return { keys: list_of_groups, values: values };
  }

  export function calc_or4_block(
    data,
    column_name,
    marketing_start_date,
    marketing_end_date,
    marketing_start_date_compare,
    marketing_end_date_compare,
  ) {
    let ret = {};
    let months = get_month_index_list();

    // console.log('months: ', months);

    // console.log('data: ', data);

    ret["per_month"] = calc_per_month(data, months, column_name);
    ret["per_country"] = calc_per_country(data, months, column_name);
    ret["per_salesperson"] = calc_per_salesperson(data, months, column_name);
    ret["per_campaign"] = calc_per_campaign(data, months, column_name);
    ret["per_source"] = calc_per_source(data, months, column_name);

    let tables = {};
    tables["country_table"] = calc_table(
      data,
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
      "country",
      column_name,
    );
    tables["source_table"] = calc_table(
      data,
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
      "source",
      column_name,
    );
    tables["salesperson_table"] = calc_table(
      data,
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
      "user",
      column_name,
    );
    tables["campaign_table"] = calc_table(
      data,
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
      "campaign",
      column_name,
    );

    tables["sum"] = tables["country_table"]["sum"];
    tables["sum_compare"] = tables["country_table"]["sum_compare"];

    ret["tables"] = tables;

    // console.log('tables: ', tables);
    // console.log('ret: ', ret);

    return ret;
  }

  function calc_table(
    data,
    marketing_start_date,
    marketing_end_date,
    marketing_start_date_compare,
    marketing_end_date_compare,
    aufteilungsname,
    date_field,
  ) {
    // pro Eintrag ist name, summe und summe compare
    let final_dict = {};
    let sum = 0;
    let sum_compare = 0;

    data.forEach((element) => {
      if (!(aufteilungsname in element) || !(date_field in element)) {
        return;
      }

      if (!element[date_field]) {
        return;
      }

      var auteilungsname_local = element[aufteilungsname];
      var date = new Date(element[date_field]);

      // console.log("element[date_field]: ", element[date_field])
      // if(date_field == "date_closed" && element[date_field].substring(0,7) == "2022-02"){
      //   console.log("marketing closed: ", element)
      // }

      if (date <= marketing_end_date && date >= marketing_start_date) {
        if (!(auteilungsname_local in final_dict)) {
          // console.log('create auteilungsname: ', auteilungsname_local);
          final_dict[auteilungsname_local] = { name: auteilungsname_local, sum: 0, sum_compare: 0 };
        }
        final_dict[auteilungsname_local]["sum"] = final_dict[auteilungsname_local]["sum"] + 1;
        sum = sum + 1;
      }

      if (date <= marketing_end_date_compare && date >= marketing_start_date_compare) {
        if (!(auteilungsname_local in final_dict)) {
          // console.log('create auteilungsname compare: ', auteilungsname_local);
          final_dict[auteilungsname_local] = { name: auteilungsname_local, sum: 0, sum_compare: 0 };
        }
        final_dict[auteilungsname_local]["sum_compare"] = final_dict[auteilungsname_local]["sum_compare"] + 1;
        sum_compare = sum_compare + 1;
      }
    });

    return { sum: sum, sum_compare: sum_compare, values: Object.values(final_dict) };
  }

  export function calc_or4_block_boundaries(
    data,
    column_name_lower,
    column_name_upper,
    marketing_start_date,
    marketing_end_date,
    marketing_start_date_compare,
    marketing_end_date_compare,
  ) {
    let ret = {};
    let months = get_month_index_list();

    // console.log('months: ', months);

    // console.log('data: ', data);

    ret["per_month"] = linechart_without_grouping_boundaries(data, months, column_name_lower, column_name_upper);
    ret["per_country"] = linechart_with_grouping_boundaries(data, months, column_name_lower, column_name_upper, "country");
    ret["per_salesperson"] = linechart_with_grouping_boundaries(data, months, column_name_lower, column_name_upper, "user");
    ret["per_campaign"] = linechart_with_grouping_boundaries(data, months, column_name_lower, column_name_upper, "campaign");
    ret["per_source"] = linechart_with_grouping_boundaries(data, months, column_name_lower, column_name_upper, "source");

    let tables = {};
    tables["country_table"] = calc_table_with_boundaries(
      data,
      column_name_lower,
      column_name_upper,
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
      "country",
    );
    tables["source_table"] = calc_table_with_boundaries(
      data,
      column_name_lower,
      column_name_upper,
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
      "source",
    );
    tables["salesperson_table"] = calc_table_with_boundaries(
      data,
      column_name_lower,
      column_name_upper,
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
      "user",
    );
    tables["campaign_table"] = calc_table_with_boundaries(
      data,
      column_name_lower,
      column_name_upper,
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
      "campaign",
    );

    // console.log('tables: ', tables);

    tables["sum"] = tables["country_table"]["sum"];
    tables["sum_compare"] = tables["country_table"]["sum_compare"];

    ret["tables"] = tables;

    // console.log("ret['per_country']: ", ret['per_country'])

    return ret;
  }

  function calc_table_with_boundaries(
    data,
    column_name_lower,
    column_name_upper,
    marketing_start_date,
    marketing_end_date,
    marketing_start_date_compare,
    marketing_end_date_compare,
    aufteilungsname,
  ) {
    let final_dict = {};
    let sum = 0;
    let sum_compare = 0;

    // console.log('data: ', data);
    data.forEach((element) => {
      if (!(aufteilungsname in element)) {
        return;
      }

      if (!(column_name_lower in element) && !(column_name_upper in element)) {
        // console.log('column_name_upper nicht da');
        return;
      }

      // console.log("kommt hier her1")

      var auteilungsname_local = element[aufteilungsname];
      var date_lower = false;
      if (element[column_name_lower]) {
        date_lower = new Date(element[column_name_lower]);
      }
      var date_upper = false;
      if (element[column_name_upper]) {
        date_upper = new Date(element[column_name_upper]);
      }

      ///ORIGINAL

      // wenn alle daten verfügbar:
      if (
        !date_upper ||
        (marketing_end_date > date_lower && (marketing_end_date < date_upper || !date_upper)) ||
        (marketing_start_date > date_lower && (marketing_start_date < date_upper || !date_upper)) ||
        (marketing_start_date < date_lower && (marketing_end_date > date_upper || !date_upper))
      ) {
        if (!(auteilungsname_local in final_dict)) {
          final_dict[auteilungsname_local] = { name: auteilungsname_local, sum: 0, sum_compare: 0 };
        }

        // console.log("element: ", element)
        // console.log("date_lower: ", date_lower)
        // console.log("date_upper: ", date_upper)

        final_dict[auteilungsname_local]["sum"] = final_dict[auteilungsname_local]["sum"] + 1;
        sum = sum + 1;
      }

      ///VERGLEICH
      if (
        !date_upper ||
        (marketing_end_date_compare > date_lower && (marketing_end_date_compare < date_upper || !date_upper)) ||
        (marketing_start_date_compare > date_lower && (marketing_start_date_compare < date_upper || !date_upper)) ||
        (marketing_start_date_compare < date_lower && (marketing_end_date_compare > date_upper || !date_upper))
      ) {
        if (!(auteilungsname_local in final_dict)) {
          final_dict[auteilungsname_local] = { name: auteilungsname_local, sum: 0, sum_compare: 0 };
        }
        final_dict[auteilungsname_local]["sum_compare"] = final_dict[auteilungsname_local]["sum_compare"] + 1;
        sum_compare = sum_compare + 1;
      }
    });

    return { sum: sum, sum_compare: sum_compare, values: Object.values(final_dict) };
  }

  function linechart_with_grouping_boundaries(data, months, column_name_lower, column_name_upper, group_field) {
    var tmp = list_to_dict_with_keys_and_grouping(data, months, group_field);
    var values_dict = tmp["dict"];
    var list_of_groups = tmp["list_of_groups"];

    // console.log("values_dict: ",values_dict)

    let values = [];

    months.forEach((m) => {
      data.forEach((element) => {
        if (element[column_name_lower]) {
          var group_value = element[group_field];

          if (!group_value) {
            return;
          }

          if (!element[column_name_upper] && date_smaller_equal_month_index(m, element[column_name_lower])) {
            values_dict[m][group_value] = values_dict[m][group_value] + 1;
          } else {
            if (
              date_smaller_equal_month_index(m, element[column_name_lower]) &&
              date_greater_equal_month_index(m, element[column_name_upper])
            ) {
              values_dict[m][group_value] = values_dict[m][group_value] + 1;
            }
          }
        }
      });
    });

    var values_lists = [];
    tmp["list_of_groups"].forEach((g) => {
      var list_of_values_one_group = [];
      months.forEach((m) => {
        list_of_values_one_group.push(values_dict[m][g]);
      });
      values_lists.push(list_of_values_one_group);
    });

    // console.log('VALUES DICT GROUP: ', values_dict);

    return create_multi_line_chart_dataset(months, values_lists, tmp["list_of_groups"]);
  }

  function linechart_without_grouping_boundaries(data, months, column_name_lower, column_name_upper) {
    let values_dict = list_to_dict_with_keys(months);
    let values = [];

    months.forEach((m) => {
      data.forEach((element) => {
        if (element[column_name_lower]) {
          if (!element[column_name_upper] && date_smaller_equal_month_index(m, element[column_name_lower])) {
            values_dict[m] = values_dict[m] + 1;
          } else {
            if (
              date_smaller_equal_month_index(m, element[column_name_lower]) &&
              date_greater_equal_month_index(m, element[column_name_upper])
            ) {
              values_dict[m] = values_dict[m] + 1;
            }
          }
        }
      });
    });

    months.forEach((m) => {
      values.push(values_dict[m]);
    });

    return create_single_line_chart_dataset(months, values);
  }

  function calc_per_month(data, months, column_name) {
    return linechart_without_grouping(data, months, column_name);
  }
  function calc_per_country(data, months, column_name) {
    return linechart_with_grouping(data, months, column_name, "country");
  }
  function calc_per_salesperson(data, months, column_name) {
    return linechart_with_grouping(data, months, column_name, "user");
  }
  function calc_per_campaign(data, months, column_name) {
    return linechart_with_grouping(data, months, column_name, "campaign");
  }
  function calc_per_source(data, months, column_name) {
    return linechart_with_grouping(data, months, column_name, "source");
  }

  function linechart_without_grouping(data, months, column_name) {
    let values_dict = list_to_dict_with_keys(months);
    let values = [];

    data.forEach((element) => {
      if (element[column_name]) {
        values_dict[element[column_name].substring(0, 7)] = values_dict[element[column_name].substring(0, 7)] + 1;
      }
    });

    months.forEach((m) => {
      values.push(values_dict[m]);
    });

    return create_single_line_chart_dataset(months, values);
  }

  function linechart_with_grouping(data, months, column_name, group_field) {
    var tmp = list_to_dict_with_keys_and_grouping(data, months, group_field);
    let values_dict = tmp["dict"];

    // console.log('values_dict: ', values_dict);

    data.forEach((element) => {
      if (element[column_name]) {
        // console.log('column_name: ', element[column_name]);
        if (element[group_field]) {
          // console.log('group_field: ', element[group_field]);

          values_dict[element[column_name].substring(0, 7)][element[group_field]] =
            values_dict[element[column_name].substring(0, 7)][element[group_field]] + 1;
        }
      }
    });

    var values_lists = [];
    tmp["list_of_groups"].forEach((g) => {
      var list_of_values_one_group = [];
      months.forEach((m) => {
        list_of_values_one_group.push(values_dict[m][g]);
      });
      values_lists.push(list_of_values_one_group);
    });

    // console.log('VALUES DICT GROUP: ', values_dict);

    return create_multi_line_chart_dataset(months, values_lists, tmp["list_of_groups"]);
  }

  function list_to_dict_with_keys_and_grouping(data, keys, group_field) {
    let ret_dict = list_to_dict_with_keys_dict(keys);
    let list_of_groups = get_list_of_groups(data, group_field);

    // console.log('list_of_groups: ', list_of_groups);

    list_of_groups.forEach((g) => {
      keys.forEach((k) => {
        ret_dict[k][g] = 0;
      });
    });

    return { dict: ret_dict, list_of_groups: list_of_groups };
  }

  function get_list_of_groups(data, group_field) {
    let list_of_groups = [];

    // console.log('data: ', data);

    data.forEach((element) => {
      //values_dict[element[column_name].substring(0,7)] = values_dict[element[column_name].substring(0,7)] + 1;
      if (element[group_field]) {
        if (!list_of_groups.includes(element[group_field])) {
          list_of_groups.push(element[group_field]);
        }
      }
    });

    return list_of_groups;
  }

  function list_to_dict_with_keys(keys) {
    let ret_dict = {};

    keys.forEach((k) => {
      ret_dict[k] = 0;
    });

    return ret_dict;
  }

  function list_to_dict_with_keys_dict(keys) {
    let ret_dict = {};

    keys.forEach((k) => {
      ret_dict[k] = {};
    });

    return ret_dict;
  }

  function get_month_index_list() {
    let end_date_obj;
    let start_date_obj;

    end_date_obj = new Date();
    start_date_obj = new Date(2020, 3, 1);

    start_date_obj.setDate(1);
    end_date_obj.setDate(1);

    start_date_obj.setHours(0);
    start_date_obj.setMinutes(0);
    start_date_obj.setSeconds(0);

    end_date_obj.setHours(0);
    end_date_obj.setMinutes(0);
    end_date_obj.setSeconds(0);

    let list_of_indexes = [];

    //    console.log("start_date_obj: ", start_date_obj)
    // console.log("end_date_obj: ", end_date_obj)

    while (start_date_obj <= end_date_obj) {
      let current_month_index;
      if (start_date_obj.getMonth() + 1 < 10) {
        current_month_index = start_date_obj.getFullYear().toString() + "-0" + (start_date_obj.getMonth() + 1).toString();
      } else {
        current_month_index = start_date_obj.getFullYear().toString() + "-" + (start_date_obj.getMonth() + 1).toString();
      }

      list_of_indexes.push(current_month_index);
      start_date_obj.setMonth(start_date_obj.getMonth() + 1);
    }

    return list_of_indexes;
  }

  function date_smaller_equal_month_index(month_index, date) {
    var x = month_index.substring(0, 7);
    var y = date.substring(0, 7);

    var year_x = parseInt(x.substring(0, 4));
    var month_x = parseInt(x.substring(5, 7));
    var year_y = parseInt(y.substring(0, 4));
    var month_y = parseInt(y.substring(5, 7));

    if (year_y < year_x) {
      return true;
    }
    if (year_y == year_x) {
      if (month_y <= month_x) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  function date_greater_equal_month_index(month_index, date) {
    var x = month_index.substring(0, 7);
    var y = date.substring(0, 7);

    var year_x = parseInt(x.substring(0, 4));
    var month_x = parseInt(x.substring(5, 7));
    var year_y = parseInt(y.substring(0, 4));
    var month_y = parseInt(y.substring(5, 7));

    if (year_y > year_x) {
      return true;
    }
    if (year_y == year_x) {
      if (month_y >= month_x) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
</script>
